export default "__VITE_ASSET__B1ECD6qE__"